require('../../../corporate-template/js/feature/center-list-spot.js');